<template>
  <div>
    <div class="dynamic-module" v-for="(question,index) in dynamicModule.questionList" :key="index">
      <!-- <div class="row"> -->
      <div class="row">
        <div class="inner-title col-sm text-left pb-0">{{index+1}}. {{question.question}}</div>
        <div class="col-1 text-left">
          <span v-for="(Answer,index) in question.savedAnswer" :key="index">
            <span v-for="(savedAnswerObj,index2) in Answer" :key="index2">
              <span
                v-if="savedAnswerObj.keyValue == 'Yes' || savedAnswerObj.keyValue == 'No'"
              >{{savedAnswerObj.keyValue}}</span>
            </span>
          </span>
        </div>
        <!-------------------------------------- new task --------------------------------------------------------------->
        <div class="col-sm text-left">
          <span v-if="question.considerControlType == 'N' && question.addRow =='N'">
            <span v-if="question.controlType == 'D' || question.controlType == 'R'">
              <span v-for="(savedanswer,index) in question.savedAnswer" :key="index">
                <div class="col-sm text-left">
                  <span v-for="(answer,index) in savedanswer" :key="index">{{answer.keyValue}}</span>
                </div>
              </span>
            </span>
          </span>

          <span
            v-if="(question.controlType == 'R' || question.controlType == 'U' || question.controlType == 'T' )
            && question.considerControlType == 'Y' 
            && question.answerResponse[0].additionalQuestions == '' && question.addRow =='N'"
          >
            <span v-for="(rowSavedAnswer,index) in question.savedAnswer" :key="index">
              <span v-for="(rowSavedAnswer,index) in rowSavedAnswer" :key="index">
                <div class="col-sm text-left" v-if="rowSavedAnswer.keyValue != 'Yes'">
                  <!-- <a
                    v-if="question.controlType == 'U'"
                    @click="showFile(rowSavedAnswer.keyValue)"
                    href="#"
                  >{{getAttachmentName(rowSavedAnswer.keyValue)}}</a>-->
                  <ul v-if="question.controlType == 'U'">
                    <li>
                      <a
                        @click="showFile(rowSavedAnswer.keyValue)"
                        href="#"
                      >{{getAttachmentName(rowSavedAnswer.keyValue)}}</a>
                    </li>
                  </ul>
                  <span v-if="question.controlType != 'U'">{{rowSavedAnswer.keyValue}}</span>
                </div>
              </span>
            </span>
          </span>

          <span v-for="(answer,index) in question.answerResponse" :key="index">
            <span v-for="(additionalQuestion,index2) in answer.additionalQuestions" :key="index2">
              <span v-if="additionalQuestion.additionalAnswerResponse.length == 1">
                <span v-if="answer.keyDesc == 'Yes'">
                  <!-- v-if="additionalQuestion.additionalAnswerResponse[0].controlType=='U'" -->
                  <span
                    v-for="(savedAnswers,indexAnswer) in question.addRowSavedAnswer"
                    :key="indexAnswer"
                  >
                    <span v-for="(savedAnswer,indexAnswer2) in savedAnswers" :key="indexAnswer2">
                      <span v-if="savedAnswer.controlType == 'U'">
                        <ul>
                          <li>
                            <a
                              @click="showFile(savedAnswer.keyValue)"
                              href="#"
                            >{{getAttachmentName(savedAnswer.keyValue)}}</a>
                          </li>
                        </ul>
                      </span>
                      <div v-else class="col-sm text-left">
                        <span>{{savedAnswer.keyValue}}</span>
                      </div>
                    </span>
                  </span>
                </span>
                <!-- to be added -> 2nd level of No selected -->
                <span v-if="answer.keyDesc == 'No'"></span>
              </span>
            </span>
          </span>
        </div>
      </div>

      <div class="pb-2">
        <span v-if="question.addRow == 'N'">
          <!-- Yes Or No type answer -->

          <!-- <span>
          <span
            v-for="(answer,index) in question.savedAnswerResponse"
            :key="index"
            checkvalue="answer.keyValue"
          >
            <div class="text-right m-0 mb-0">
              <span v-if="answer.keyValue == 'Yes' || answer.keyValue == 'No'">{{answer.keyValue}}</span>
            </div>
          </span>
          </span>-->
          <span v-for="(Answer,index) in question.savedAnswer" :key="index">
            <span v-for="(savedAnswerObj,index1) in Answer" :key="index1">
              <span v-if="savedAnswerObj.keyValue == 'Yes'">
                <!-- -->
                <span>
                  <span v-for="(check,i) in question.answerResponse" :key="i">
                    <span v-for="(add,index1) in check.additionalQuestions" :key="index1">
                      <!-- additional question -> add row == N -->
                      <span v-if="add.addRow == 'N' ">
                        <span v-if="add.additionalAnswerResponse.length > 1">
                          <!--  -->
                          <table
                            v-if="check.keyValue == 'Yes' || check.keyDesc == 'Yes'"
                            class="table table-striped mt-2"
                          >
                            <thead>
                              <tr>
                                <th
                                  v-for="(additionalAnswer,index) in add.additionalAnswerResponse"
                                  :key="index"
                                >{{additionalAnswer.displayName}}</th>
                              </tr>
                            </thead>
                            <tbody class="text-left">
                              <tr>
                                <td
                                  v-for="(answer,index) in question.addRowSavedAnswer[0]"
                                  :key="index"
                                >{{answer.keyValue}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </span>
                      </span>
                      <!-- <tr v-if="add.displayName">
                              <th>{{add.displayName}}</th>
                      </tr>-->
                      <div class="pb-0">
                        <table
                          v-if="add.addRow == 'Y' 
                        && add.additionalAnswerResponse.length > 1 && check.keyDesc == 'Yes'"
                          class="table table-striped"
                        >
                          <thead>
                            <!-- add.displayName -->
                            <!-- <tr v-if="add.displayName">
                              <th>{{add.displayName}}</th>
                            </tr>-->
                            <tr>
                              <th
                                v-for="(heading,index) in add.additionalAnswerResponse"
                                :key="index"
                              >{{heading.displayName}}</th>
                            </tr>
                          </thead>
                          <tbody class="text-left">
                            <tr v-for="(value,index) in question.addRowSavedAnswer" :key="index">
                              <td v-for="(answer,index) in value" :key="index">
                                <!-- {{answer.keyValue}} -->
                                <span v-if="answer.controlType =='U'">
                                  <a
                                    @click="showFile(answer.keyValue)"
                                    href="#"
                                  >{{getAttachmentName(answer.keyValue)}}</a>
                                </span>
                                <span v-else>{{answer.keyValue}}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </span>
      </div>

      <div class="pb-2">
        <div v-if="question.addRow == 'Y'">
          <table class="table table-striped">
            <thead>
              <tr>
                <th
                  v-for="(heading,index) in question.answerResponse"
                  :key="index"
                >{{heading.displayName}}</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-for="(value,index) in question.savedAnswer" :key="index">
                <td v-for="(answer,index) in value" :key="index">{{answer.keyValue}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <span v-for="(additional,index) in question.answerResponse" :key="index">
        <span v-if="question.addRow == 'Y' ||additional.addRow == 'Y' ">
          <span v-if="question.controlType == 'R'">
            <!-- <span v-for="(answer,index) in question.savedAnswerResponse" :key="index">
                <div class="col-sm text-left">{{answer.keyValue}}</div>
            </span>-->
          </span>
        </span>
      </span>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </div>
  <!-- </div> -->
</template>
<script>
import axios from "axios";
import loadingSpinner from "../../widgets/LoadingSpinner";
export default {
  components: {
    "w-loadingSpinner": loadingSpinner
  },
  props: ["dynamicModule"],
  data() {
    return {
      loading: false,
      answer: ""
    };
  },
  methods: {
    showFile(documentId) {   
      this.loading = true;
      axios
        .get(`http://localhost:8080/api/fileDownload/${documentId}`, {
          responseType: "blob"
        })
        .then(res => {
          this.loading = false;
          console.log("File API is called.");
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", res.config.url.split(/_(.+)/)[1]); //or any other extension
          document.body.appendChild(link);
          link.click();
          console.log("link clicked");
          // alert("Downlodeded1");
        })
        .catch(e => {
          this.loading = false;
          console.log("file download error.");
          alert("File Download Error....");
        });
    },
    getAttachmentName(documentId) {
      let attachmentName = "";
      attachmentName = documentId.split(/_(.+)/)[1]
        ? documentId.split(/_(.+)/)[1]
        : documentId;
      return attachmentName;
    }
  }
};
</script>
<style scoped>
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
  width: 20%;
}
.dynamic-module {
  font-family: "Source Sans Pro", sans-serif;
}
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  font-stretch: normal;
  line-height: 1.25;
  text-align: left;
  padding-bottom: 1%;

  /* width: 100%;
  height: 20px; */
  /* font-family: SourceSansProSemiBold;
  font-size: 12px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal; */
  /* line-height: 3.06;
  letter-spacing: 0.16px; */
  text-align: left;
  color: #212121;
  /* font-family: "Source Sans Pro", sans-serif;
  font-weight: bold;
  font-size: 13px; */
}
</style>